import React from "react";
import { Save, Undo2, Redo2, Grid3X3, LogOut, Play, Pause, Sun, Moon, CloudRain, SunMoon } from "lucide-react";
import { C, FONT_BODY } from "./theme";

// Mode langit: siklus Otomatis → Siang → Malam → Hujan
export const SKY_MODES = [["auto", SunMoon, "Otomatis"], ["day", Sun, "Siang"], ["night", Moon, "Malam"], ["rain", CloudRain, "Hujan"]];

export const pillBtn = (onClickFn, Icon, label, testid, title) => (
  <button data-testid={testid} onClick={onClickFn} title={title}
    style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "10px 15px", borderRadius: 99, border: `1.5px solid ${C.divider}`, background: "#fff", color: C.ink, fontSize: 12, fontWeight: 700, fontFamily: FONT_BODY, transition: "border-color 0.15s" }}
    onMouseEnter={e => e.currentTarget.style.borderColor = C.sub}
    onMouseLeave={e => e.currentTarget.style.borderColor = C.divider}>
    <Icon size={14} color={C.blue} /> {label}
  </button>
);

export const circleBtn = (onClickFn, Icon, testid, title) => (
  <button key={testid} data-testid={testid} onClick={onClickFn} title={title}
    style={{ width: 36, height: 36, borderRadius: "50%", border: `1.5px solid ${C.divider}`, display: "grid", placeItems: "center", background: "transparent", color: C.ink, transition: "border-color 0.15s" }}
    onMouseEnter={e => e.currentTarget.style.borderColor = C.sub}
    onMouseLeave={e => e.currentTarget.style.borderColor = C.divider}>
    <Icon size={15} />
  </button>
);

// HEADER editor: kapsul (pill kota) melayang di tengah, aksi di kanan
export function EditorHeader({ headerExtra, animOn, onToggleAnim, skyMode, onCycleSky, onUndo, onRedo, showGrid, onToggleGrid, onLogout, onSave }) {
  const skyIdx = SKY_MODES.findIndex(m => m[0] === skyMode);
  const SkyIcon = SKY_MODES[skyIdx][1];
  return (
  <header style={{ height: 60, flex: "none", display: "flex", alignItems: "center", gap: 12, margin: "14px 18px 12px", zIndex: 50 }}>
    <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
      {headerExtra && (
        <div style={{ display: "inline-flex", alignItems: "center", gap: 4, background: "#fff", borderRadius: 99, padding: "6px 8px", boxShadow: "0 8px 24px rgba(20,20,20,0.08)", maxWidth: "100%", overflowX: "auto" }}>
          {headerExtra}
        </div>
      )}
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {pillBtn(onToggleAnim, animOn ? Pause : Play, animOn ? "Animasi: Jalan" : "Animasi: Stop", "anim-toggle-btn",
        animOn ? "Jeda animasi kehidupan kota (awan, burung, ikan, perahu, kendaraan, warga)" : "Jalankan kembali animasi kehidupan kota")}
      {pillBtn(onCycleSky, SkyIcon, SKY_MODES[skyIdx][2], "sky-mode-btn", "Mode langit & cuaca — klik untuk ganti")}
      {circleBtn(onUndo, Undo2, "undo-btn", "Batal")}
      {circleBtn(onRedo, Redo2, "redo-btn", "Ulang")}
      {circleBtn(onToggleGrid, Grid3X3, "grid-toggle-btn", showGrid ? "Grid ON" : "Grid OFF")}
      {onLogout && circleBtn(onLogout, LogOut, "logout-btn", "Keluar")}
      <button data-testid="save-btn" onClick={onSave}
        style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "10px 20px", background: C.blue, border: 0, borderRadius: 99, color: "#fff", fontSize: 13, fontWeight: 700, marginLeft: 4, transition: "opacity 0.15s", fontFamily: FONT_BODY }}
        onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
        onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
        <Save size={15} /> Simpan
      </button>
    </div>
  </header>
  );
}
